<template>
  <div class="my-4">
    <v-text-field
      light
      label="Title"
      v-model="item.title"
      type="text"
      required
      color="amber"
      placeholder="Name"
      class="my-10"
    ></v-text-field>
    <v-textarea
      light
      label="Notes"
      color="amber"
      v-model.trim="item.body"
      :rows="2"
      :autoGrow="true"
      :hide-details="true"
    />
    <div>
      <v-switch
        light
        :items="colors"
        label="Does this require a logo?"
        v-model="item.logo"
        class="mt-8"
        color="amber"
      ></v-switch>
    </div>
    <v-select
      :items="audiences"
      label="Audiences"
      multiple
      v-model.trim="item.audiences"
      light
    ></v-select>

    <div class="d-flex justify-end align-center pr-3">
      <v-btn @click="submit" small color="amber" class="my-4" light
        >Change</v-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "EcoSystemForm",
  props: {
    newItem: {
      type: Object,
      default: () => {},
    },
    colors: {
      type: Array,
      default: () => [],
    },
    audiences: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      item: this.newItem,
    };
  },
  methods: {
    submit() {
      this.$emit("update", this.item);
      this.$set(this.item, {});
    },
  },
};
</script>
